import React, { Component, useState } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import VerificationInput from "react-verification-input";
import instance from "../../../store/actions/instance";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useReadOTP } from "react-read-otp";
import moment from "moment";
import MuiPhoneNumber from "material-ui-phone-number";
import { isValidPhoneNumber } from "react-phone-number-input";
import EditIcon from "@material-ui/icons/Edit";

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};
const getPhoneDigits = (phone) => (phone || "").replace(/\D/g, "");
const isEgyptPhone = (phone) => getPhoneDigits(phone).startsWith("20");
const isEgyptianMobilePhoneNumber = (phone) => {
  if (!phone) return false;
  const digits = getPhoneDigits(phone);
  if (!digits.startsWith("20")) return false;
  const nationalNumber = digits.slice(2);
  if (nationalNumber.startsWith("0")) {
    return /^(010|011|012|015)\d{8}$/.test(nationalNumber);
  }
  return /^(10|11|12|15)\d{8}$/.test(nationalNumber);
};

function VerInput({ error, onChange, value }) {
  const [otp, setOTP] = useState("");
  useReadOTP(setOTP);
  return (
    <VerificationInput
      value={otp || value}
      validChars="0-9"
      inputProps={{ type: "tel" }}
      length={4}
      placeholder={"_"}
      classNames={{
        //container: "container",
        character: !error ? "character" : "character-error",
        characterInactive: "character--inactive",
        characterSelected: !error
          ? "character--selected"
          : "character--selected--error",
      }}
      onChange={(e) => {
        onChange(e);
        setOTP(e);
      }}
    />
  );
}
class VerifyPhone extends Component {
  state = {
    code: "",
    verifyLoading: false,
    error: false,
    lastResend: localStorage.getItem("lastResend") || null,
    time: 1,
    phone: this.props.phone,
    phoneTemp: "",
  };
  verifyButtonDisabled = () => {
    const { code } = this.state;
    if (!code?.trim() || code.trim().length !== 4) return true;
    if (!!this.state.phoneTemp) return true;
    return false;
  };

  verifyPhone = async () => {
    this.setState({ verifyLoading: true });
    try {
      const res = await instance.post("/verify_phone/", {
        number: this.state.phone,
        code: this.state.code,
      });
      if (res.data.success) {
        localStorage.setItem("phone_verified", this.state.phone);
        localStorage.removeItem("lastResendPh");
        this.props.onClose(true);
      } else this.setState({ error: true });
    } catch (e) {
      console.error(e);
    }
    this.setState({ verifyLoading: false });
  };

  sendVerificationCode = async (resend, usePhone = null) => {
    const lastResend = localStorage.getItem("lastResend");
    if (!lastResend) {
      localStorage.setItem(
        "lastResend",
        moment().format("YYYY-MM-DD|HH:mm:ss")
      );
      this.startTimer();
    } else {
      const lastResendMom = moment(lastResend, "YYYY-MM-DD|HH:mm:ss");
      if (moment().diff(lastResendMom, "seconds") < 60) return;
      else {
        localStorage.setItem(
          "lastResend",
          moment().format("YYYY-MM-DD|HH:mm:ss")
        );
        this.startTimer();
      }
    }
    localStorage.setItem("lastResendPh", usePhone || this.state.phone);
    try {
      const res = await instance.post("/send_phone_verification/", {
        number: usePhone || this.state.phone,
        resend: resend,
        language: this.props.language,
      });
    } catch (e) {
      console.error(e);
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevState.code?.length !== this.state.code?.length &&
      this.state.code?.length === 4
    ) {
      this.verifyPhone();
    }

    if (!prevProps.open && this.props.open === true) {
      // console.log(localStorage.getItem("lastResendPh"));
      // if (this.state.phone !== localStorage.getItem("lastResendPh"))
      this.sendVerificationCode();
    }
  };

  handleChange = (e, eventPhone) => {
    const { settings } = this.props;

    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phoneTemp: e });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
      if (e.length >= this.state.phone.length)
        this.setState({ phoneError: false });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  handlePhoneSave = () => {
    const isEgyptianPhone = isEgyptPhone(this.state.phoneTemp);
    const isValidPhone = isEgyptianPhone
      ? isEgyptianMobilePhoneNumber(this.state.phoneTemp)
      : isValidPhoneNumber(this.state.phoneTemp) ||
        isVirginPhoneNumber(this.state.phoneTemp);

    if (
      !isValidPhone ||
      this.state.countryDialCode == this.state.phoneTemp.substring(1)
    ) {
      this.setState({ phoneError: true });
      return;
    }
    const newPhone = this.state.phoneTemp;
    this.setState({
      phone: newPhone,
      phoneTemp: "",
      phoneEditing: false,
    });
    if (newPhone !== this.props.phone) {
      localStorage.removeItem("lastResend");
      localStorage.removeItem("lastResendPh");
      localStorage.removeItem("phone_verified");
      this.props.editCustomerPhone(newPhone);
      this.sendVerificationCode(true, newPhone);
      this.props.history.replace("/checkout/confirmation");
    }
  };
  startTimer = () => {
    this.timer = setInterval(() => {
      if (this.state.time === 60) {
        this.setState({ time: 1 });
        this.endTimer();
      } else this.setState({ time: this.state.time + 1 });
    }, 1000);
  };

  endTimer = () => {
    clearInterval(this.timer);
  };

  showResendCounter = () => {
    const lastResend = localStorage.getItem("lastResend");
    if (!lastResend) return false;
    const lastResendMom = moment(lastResend, "YYYY-MM-DD|HH:mm:ss");
    if (moment().diff(lastResendMom, "seconds") < 60) {
      if (!this.timer) this.startTimer();
      return true;
    }
    return false;
  };
  render() {
    const {
      language,
      phone,
      themeColor,
      countries,
      settings,
      store,
      address,
      disableEditing,
    } = this.props;

    const timeDiff =
      60 -
      moment().diff(
        moment(localStorage.getItem("lastResend"), "YYYY-MM-DD|HH:mm:ss"),
        "seconds"
      );

    const countryObj = countries?.find((c) => c?.id === address?.country);

    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };

    return (
      <Dialog
        open={this.props.open}
        onClose={() => {
          this.setState({ error: false });
          this.props.onClose();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { width: 400 } }}
      >
        <DialogTitle
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          <span style={{ fontWeight: "bold" }}>
            {language === "arabic" ? "تحقق من الهاتف" : "Verify Phone"}
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              textAlign: language == "english" ? "left" : "right",
              color: "#333",
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
          >
            {this.state.phoneEditing ? (
              <>
                {language === "arabic"
                  ? "تعديل على رقم الهاتف"
                  : "Edit your phone number"}
              </>
            ) : (
              <>
                {language === "arabic"
                  ? "تم ارسال رمز تحقق مكون من 4 ارقام الى"
                  : "A 4-digit code has been sent to"}
              </>
            )}
            :
            {!this.state.phoneEditing ? (
              <span
                className="bold"
                style={{
                  unicodeBidi: "plaintext",
                  display: "block",
                  marginTop: 12,
                }}
              >
                {language === "english" ? this.state.phone : ""}{" "}
                {!disableEditing && (
                  <Button
                    color="primary"
                    style={{ position: "relative", top: -1 }}
                    onClick={() => this.setState({ phoneEditing: true })}
                    disabled={!!this.state.phoneTemp}
                  >
                    <EditIcon
                      style={{ fontSize: 12 }}
                      className={language === "arabic" ? "ml-2" : "mr-2"}
                    />
                    {language === "arabic" ? "تعديل" : "Edit"}
                  </Button>
                )}
                {language === "arabic" ? this.state.phone : ""}{" "}
              </span>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto 50px",
                  columnGap: 10,
                }}
              >
                <MuiPhoneNumber
                  defaultCountry={
                    countryObj?.dial_code || store.default_dial_code || "kw"
                  }
                  onlyCountries={
                    settings.show_all_country_codes
                      ? []
                      : [
                          "kw",
                          "sa",
                          "qa",
                          "om",
                          "ae",
                          "bh",
                          "sy",
                          "lb",
                          "jo",
                          "eg",
                          "us",
                          "uk",
                          "cn",
                        ]
                  }
                  excludeCountries={["il"]}
                  countryCodeEditable={false}
                  disableAreaCodes={true}
                  error={this.state.phoneError}
                  autoComplete="tel"
                  //label={language == "english" ? "Phone *" : "رقم الهاتف *"}
                  className="mt-2 mb-4"
                  color={themeColor}
                  onChange={this.handleChange}
                  key={this.state.phoneFieldKey}
                  value={this.state.phone}
                  fullWidth
                  style={{ direction: "ltr" }}
                  helperText={
                    this.state.phoneError
                      ? language == "english"
                        ? "Please enter your phone number"
                        : "الرجاء ادخال رقم الهاتف"
                      : ""
                  }
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                />
                <Button
                  color="primary"
                  style={{ position: "relative", top: -1 }}
                  onClick={() => this.handlePhoneSave()}
                  disabled={!this.state.phoneTemp}
                >
                  {language === "arabic" ? "حفظ" : "Save"}
                </Button>
              </div>
            )}
          </DialogContentText>
          {!this.state.phoneEditing && (
            <>
              <DialogContentText
                id="alert-dialog-description"
                style={{
                  textAlign: language == "english" ? "left" : "right",
                  color: "#333",
                }}
              >
                {language === "arabic"
                  ? "ادخله ادناه"
                  : "Please enter it below"}
              </DialogContentText>
              <VerInput
                value={this.state.value}
                error={this.state.error}
                onChange={(e) => this.setState({ code: e, error: false })}
              />

              {/* <TextField
            autoFocus
            margin="dense"
            id="code"
            label="Verification Code"
            //type="email"
            fullWidth
            variant="standard"
            onChange={(e) => this.setState({ code: e.target.value })}
          /> */}

              <div className="mt-4">
                {!this.showResendCounter() ? (
                  <p
                    className="mb-1"
                    style={{
                      direction: language === "arabic" ? "rtl" : "ltr",
                      textAlign: language === "arabic" ? "right" : "left",
                    }}
                  >
                    {language === "arabic"
                      ? "لم يصلك رمز؟"
                      : "Didn't receive a code?"}{" "}
                    <Button
                      color="primary"
                      style={{ position: "relative", top: -1 }}
                      onClick={() => this.sendVerificationCode(true)}
                      disabled={!!this.state.phoneTemp}
                    >
                      {language === "arabic" ? "اعادة ارسال" : "Resend"}
                    </Button>
                  </p>
                ) : (
                  <p
                    className="mb-1"
                    style={{
                      textAlign: language === "arabic" ? "right" : "left",
                    }}
                  >
                    {language === "arabic" ? "اعادة ارسال بعد" : "Resend in"}{" "}
                    00:{timeDiff <= 9 ? "0" : ""}
                    {timeDiff}
                  </p>
                )}
              </div>
            </>
          )}
        </DialogContent>

        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button
            onClick={() => {
              this.setState({
                error: false,
                phoneEditing: false,
                phoneTemp: "",
                code: "",
              });
              this.props.onClose();
            }}
            color="primary"
          >
            {language == "english" ? "Cancel" : "الغاء"}
          </Button>
          <Button
            onClick={() => this.verifyPhone()}
            color="primary"
            disabled={this.verifyButtonDisabled()}
          >
            {this.state.verifyLoading ? (
              <span>
                <CircularProgress
                  style={{ width: 30, height: 30, color: themeColor }}
                />
              </span>
            ) : language == "english" ? (
              "Verify"
            ) : (
              "تحقق"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
    countries: state.store.store.all_countries || state.store.store.countries,
    store: state.store.store,
    settings: state.store.store.settings,
    address: state.customers.address,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editCustomerPhone: (phone) =>
      dispatch({ type: "EDIT_CUSTOMER_PHONE", payload: phone }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyPhone);
